import styled from '@emotion/styled'
import React from 'react'
import { StyledHTMLElement } from 'shop/theme/types'
import { ProductLoader, CategoryDescriptionLoader } from '../Loader'
import { LineBreak } from '../Shop/commonStyles'
import { ProductsContainer, List, LineBreakWrapper } from './commonStyles'

export const LoadingContainer = ({ count = 6 }) => (
  <ProductsContainer>
    <LoaderWrapper>
      <CategoryDescriptionLoader />
    </LoaderWrapper>
    <List>
      {Array(count)
        .fill(null)
        .map((_, index) => (
          <React.Fragment key={`product-loader-${index + 1}`}>
            <ProductCardLoader>
              <ProductLoader />
            </ProductCardLoader>
            <LineBreakWrapper isLast={index === count - 1}>
              <LineBreak />
            </LineBreakWrapper>
          </React.Fragment>
        ))}
    </List>
  </ProductsContainer>
)

const LoaderWrapper = styled.div({
  width: '214px',
  height: '32px',
  marginBottom: '8px'
})

const ProductCardLoader = styled.li<StyledHTMLElement>(({ theme }) => ({
  padding: '12px 0',
  [theme.mediaQueries.viewport9]: {
    border: 'solid #FAFAFA 1px',
    padding: '12px',
    borderRadius: theme.borderRadius
  }
}))
